export default "__VITE_ASSET__277d966e__"